import { useRef, useState } from "react";
import { Loader2, Upload, X } from "lucide-react";
import { toast } from "sonner";
import { adminApi, errorText, imgSrc } from "../../lib/api";

export const ImageUpload = ({ value, onChange, testId, label = "Image" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await adminApi.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <p className="mb-1 text-sm text-zinc-300">{label}</p>
      <div className="flex items-center gap-4">
        <div className="grid h-20 w-28 shrink-0 place-items-center overflow-hidden rounded-xl border border-white/10 bg-[#0B0C10]">
          {value ? <img src={imgSrc(value) || undefined} alt="" className="h-full w-full object-cover" data-testid={`${testId}-preview`} /> : <span className="text-xs text-zinc-400">No image</span>}
        </div>
        <div className="flex flex-wrap gap-2">
          <button type="button" data-testid={`${testId}-btn`} onClick={() => ref.current?.click()} disabled={busy} className="btn-ghost">
            {busy ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />} Upload
          </button>
          {value && <button type="button" data-testid={`${testId}-clear`} onClick={() => onChange("")} className="btn-ghost"><X size={15} /> Remove</button>}
        </div>
        <input ref={ref} data-testid={`${testId}-input`} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={pick} />
      </div>
    </div>
  );
};
